export default function getBrightcoveIds(videoProvider) {
  if (videoProvider?.providerType !== 'brightcove') return {}

  return {
    videoId: videoProvider.videoId,
    accountId: videoProvider.accountId,
  }
}
